import DataAccess from '@/libraries/DataAccess';

const state = {
    contact: [],
    contact_list: []
}
const getters = {
    CONTACT: state => {
        return state.contact;
    },
    CONTACT_LIST: state => {
        return state.contact_list;
    }
}
const mutations = {
    SET_CONTACT: (state, contact) => {
        state.contact = contact;
    },
    ADD_CONTACT: (state, contact) => {
        state.contact.push(contact);
    },
    SET_CONTACT_LIST: (state, value) => {
        state.contact_list = value;
    },
    ADD_CONTACT_LIST: (state, value) => {
        state.contact_list.push(value);
    }
}
const actions = {
    GET_CONTACT: async (context) => {
        let url = process.env.VUE_APP_BEDP_API + "/api/excel?sheetName=SheetA";

        let data = await DataAccess.getResults(url);

        let contacts = [];

        if (data) {
            for (let i = 0; i < data.length; i++) {
                contacts.push({ question: data[i][0], answer: "" });
            }

            context.commit("SET_CONTACT", contacts);
        }
    },
    SAVE_CONTACT: async (context, contact) => {
        // save contact info

        context.commit("ADD_CONTACT", contact);
    },
    //GET_CONTACT_LIST: async (context, value) => {
    //    state.
    //},
    SAVE_CONTACT_LIST: async (context, value) => {
        context.commit("ADD_CONTACT_LIST", value);
    }
}

export default {
    state, getters, mutations, actions
}